import { render } from "./ViewSvgIcon.vue?vue&type=template&id=41fc4919"
import script from "./ViewSvgIcon.vue?vue&type=script&lang=js"
export * from "./ViewSvgIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__